export const Broadcast = () => null;
//# sourceMappingURL=Broadcast.web.js.map